<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/FacturaGuiaPorcinosFOTO">Registro Origen de Porcinos</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>
  
          <span class="card-title">Registro Factura y Guía de Porcinos</span>
          <form id="formRegistro" autocomplete="off" @submit.prevent="registro" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad required disabled>
            <input type="text" placeholder="PSG" :value=PSG required v-on:click=psgcorrespondiente()  readonly>
            <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" v-on:click=usuario() required>
            <p><h5>DATOS DE GUÍA</h5>
            <input type="date" name="fechaexpedicion" id="fechaexpedicion" placeholder="Fecha de Expedición" :value="fechaForma" v-on:change=variables() required>
            <input type="text" name="reemo" id="reemo" placeholder="Guía" pattern=".{5,100}" :value="QRForma" v-on:change=variables() @blur="validarReemo" required>
            <input type="text" name="folioreemo" id="folioreemo" placeholder="Folio Reemo" hidden='true'>
            <input type="hidden" name="upp" id="upp" placeholder="UPP origen" pattern=".{5,20}" :value="uppForma" v-on:change=variables() >
            <input type="text" name="nombreorigen" id="nombreorigen" placeholder="Nombre Origen" required>
            <input type="text" name="localidadorigen" id="localidadorigen" placeholder="Localidad">
            <input type="text" name="municipioorigen" id="municipioorigen" placeholder="Municipio">
            <input type="text" name="estadoorigen" id="estadoorigen" placeholder="Estado">
            <input type="text" name="nombredestinatario" id="nombredestinatario" placeholder="Nombre Destinatario" required>
            <input type="number" name="cantidad" id="cantidad" placeholder="Cantidad de Animales" :value="cantidadForma" v-on:change=variables() required>
                
             <b-form-select v-model="selected2" class="mb-3"  required>
                <template v-slot:first>
        <b-form-select-option :value="null" disabled>-- Selecciona especie --</b-form-select-option>
      </template>
      
      <b-form-select-option value="Porcino">Porcino</b-form-select-option>
     
    </b-form-select>   


          <h5>Captura imagen REEMO</h5>  

       <div class="file-field input-field" v-show="device==[]||show1==0">
                <div class="btn">
                <span>Foto de Reemo</span>
                <input type="file" name="fotoguia" id="fotoguia" @change="onFileChange">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text" readonly> 
                </div>
            </div>

        <div class="row" v-show="show1==1">
            <div class="col-md-6">
                
                <code v-if="device">{{ device.label }}</code>
                <div class="border">
                    <web-cam
                        ref="webcam"
                        :device-id="deviceId"
                        width="100%"
                        @started="onStarted"
                        @stopped="onStopped"
                        @error="onError"
                        @cameras="onCameras"
                        @camera-change="onCameraChange"
                    />
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <select v-model="camera">
                            <option>-- Select Device --</option>
                            <option
                                v-for="device in devices"
                                :key="device.deviceId"
                                :value="device.deviceId"
                            >{{ device.label }}</option>
                        </select>
                    </div>
                    <div class="col-md-12">
                        <button type="button" class="btn btn-primary" @click="onCapture(1)">Capturar Imagen</button>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h5>Imagen Capturada</h5><br><br><br>
                <figure class="figure">
                    <img :src="img" class="figure-img img-fluid rounded" alt="Responsive image" />
                     <figcaption class="figure-caption">Imagen Capturada</figcaption>
                </figure>
            </div>
        </div>
    
    <button type="button" class="btn btn-danger" @click="onStop(1)" v-if="devices!=[]">Apagar Cámara</button>
   <button type="button" class="btn btn-success" @click="onStart(1)" v-if="devices!=[]">Encender Cámara</button>
   <button type="button" class="btn btn-success" @click="Borrar(1)" v-if="devices!=[]">Borrar Imagen de Cámara</button>

<p><h5>DATOS FACTURA</h5>
          <input type="text" name="factura" id="factura" placeholder="Factura" pattern=".{5,20}" required>   
  <div>
    <b-form-checkbox
      id="checkbox1"
      v-model="status"
      name="checkbox1"
      value="VERIFICADO"
      unchecked-value="NO VERIFICADO"
    >
     <div><strong><h6>Se verificó que la factura coincide con la guía de tránsito</h6></strong></div>
    </b-form-checkbox>

    <div>Estado: <strong>{{ status }}</strong></div>
  </div>

<h5>Captura de Imagen Factura</h5>

  <div class="file-field input-field" v-show="device==[]||show2==0">
                <div class="btn">
                <span>Foto factura</span>
                <input type="file" name="fotofactura">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text" readonly>
                </div>
            </div>

 <div class="row" v-show="show2==1">
            <div class="col-md-6">
                
                <code v-if="device">{{ device.label }}</code>
                <div class="border">
                    <web-cam
                        ref="webcam"
                        :device-id="deviceId"
                        width="100%"
                        @started="onStarted"
                        @stopped="onStopped"
                        @error="onError"
                        @cameras="onCameras"
                        @camera-change="onCameraChange"
                    />
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <select v-model="camera">
                            <option>-- Select Device --</option>
                            <option
                                v-for="device in devices"
                                :key="device.deviceId"
                                :value="device.deviceId"
                            >{{ device.label }}</option>
                        </select>
                    </div>
                    <div class="col-md-12">
                        <button type="button" class="btn btn-primary" @click="onCapture(2)">Capturar Imagen</button>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h5>Imagen Capturada</h5><br><br><br>
                <figure class="figure">
                    <img :src="img2" class="figure-img img-fluid rounded" alt="Responsive image" />
                     <figcaption class="figure-caption">Imagen Capturada</figcaption>
                </figure>
            </div>
        </div>
    
    <button type="button" class="btn btn-danger" @click="onStop(2)" v-if="devices!=[]">Apagar Cámara</button>
   <button type="button" class="btn btn-success" @click="onStart(2)" v-if="devices!=[]">Encender Cámara</button>
   <button type="button" class="btn btn-success" @click="Borrar(2)" v-if="devices!=[]">Borrar Imagen de Cámara</button>



<p><h5>DATOS RECIBO</h5>
           
            <input type="number" name="guia" placeholder="Guía" pattern=".{4,10}" hidden='true'>
            <input type="number"  name="orden" placeholder="Recibo de Ingreso de Porcinos" pattern=".{5,10}" required>
            <input type="number"  name="corral" placeholder="Corral" pattern=".{5,10}" required>
            <input type="number"  name="permiso" placeholder="Permiso" pattern=".{3,50}" required>
            <div>
    <b-form-checkbox
      id="checkbox2"
      v-model="status2"
      name="checkbox2"
      value="VERIFICADO"
      unchecked-value="NO VERIFICADO"
    >
     <div><strong><h6>Se verificó la cantidad de animales bajados</h6></strong></div>
    </b-form-checkbox>

    <div>Estado: <strong>{{ status2 }}</strong></div>
  </div>

<h5>Captura Imagen Recibo</h5>
<div class="file-field input-field" v-show="device==[]||show3==0">
                <div class="btn">
                <span>Foto Recibo</span>
                <input type="file" name="fotorecibo">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text" readonly>
                </div>
            </div>

 <div class="row" v-show="show3==1">
            <div class="col-md-6">
                
                <code v-if="device">{{ device.label }}</code>
                <div class="border">
                    <web-cam
                        ref="webcam"
                        :device-id="deviceId"
                        width="100%"
                        @started="onStarted"
                        @stopped="onStopped"
                        @error="onError"
                        @cameras="onCameras"
                        @camera-change="onCameraChange"
                    />
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <select v-model="camera">
                            <option>-- Select Device --</option>
                            <option
                                v-for="device in devices"
                                :key="device.deviceId"
                                :value="device.deviceId"
                            >{{ device.label }}</option>
                        </select>
                    </div>
                    <div class="col-md-12">
                        <button type="button" class="btn btn-primary" @click="onCapture(3)">Capturar Imagen</button>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h5>Imagen Capturada</h5><br><br><br>
                <figure class="figure">
                    <img :src="img3" class="figure-img img-fluid rounded" alt="Responsive image" />
                     <figcaption class="figure-caption">Imagen Capturada</figcaption>
                </figure>
            </div>
        </div>
    
    <button type="button" class="btn btn-danger" @click="onStop(3)" v-if="devices!=[]">Apagar Cámara</button>
   <button type="button" class="btn btn-success" @click="onStart(3)" v-if="devices!=[]">Encender Cámara</button>
   <button type="button" class="btn btn-success" @click="Borrar(3)" v-if="devices!=[]">Borrar Imagen de Cámara</button>
<br>


<h5>Captura de Imagen de Orden de Sacrificio</h5>
<div class="file-field input-field" v-show="device==[]||show4==0">
                <div class="btn">
                <span>Foto Orden de Sacrificio (Permiso)</span>
                <input type="file" name="fotopermiso">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text" readonly>
                </div>
            </div>

            <div class="row" v-show="show4==1">
            <div class="col-md-6">
                
                <code v-if="device">{{ device.label }}</code>
                <div class="border">
                    <web-cam
                        ref="webcam"
                        :device-id="deviceId"
                        width="100%"
                        
                        @started="onStarted"
                        @stopped="onStopped"
                        @error="onError"
                        @cameras="onCameras"
                        @camera-change="onCameraChange"
                    />
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <select v-model="camera">
                            <option>-- Select Device --</option>
                            <option
                                v-for="device in devices"
                                :key="device.deviceId"
                                :value="device.deviceId"
                            >{{ device.label }}</option>
                        </select>
                    </div>
                    <div class="col-md-12">
                        <button type="button" class="btn btn-primary" @click="onCapture(4)">Capturar Imagen</button>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h5>Imagen Capturada</h5><br><br><br>
                <figure class="figure">
                    <img :src="img4" class="figure-img img-fluid rounded" alt="Responsive image" />
                     <figcaption class="figure-caption">Imagen Capturada</figcaption>
                </figure>
            </div>
        </div>
    
    <button type="button" class="btn btn-danger" @click="onStop(4)" v-if="devices!=[]">Apagar Cámara</button>
   <button type="button" class="btn btn-success" @click="onStart(4)" v-if="devices!=[]">Encender Cámara</button>
   <button type="button" class="btn btn-success" @click="Borrar(4)" v-if="devices!=[]">Borrar Imagen de Cámara</button>
<input type="text"  name="comentarios" placeholder="Comentarios" id="comentarios">

<input type="hidden" name="imgreemo" id="imgreemo" v-model=img>
              <input type="hidden" name="imgfactura" id="imgfactura" v-model=img2>
              <input type="hidden" name="imgrecibo" id="imgrecibo" v-model=img3>
              <input type="hidden" name="imgpermiso" id="imgpermiso" v-model=img4>


             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="psgForma" id="psgForma" :value=PSG>
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad>
             <input type="hidden" name="fotoForma" id="fotoForma" :value=fotoActual>
              <input type="hidden" name="especieForma2" id="especieForma2" :value=selected2>
               <input type="hidden" name="verificacionFactura" id="verificacionFactura" :value=status>
                <input type="hidden" name="verificacionIngreso" id="verificacionIngreso" :value=status2>

           
<div class="card-action">
                        <h6 style="color:Tomato;font-weight:bold;">{{corregir}}</h6>
                        <input type="submit" value="Registrar" :class="boton">
                           
        </div>
     
            </form>
       
       
    <b-card-body class="text-center">
     

      <b-card-text>
       <div>
    <h5>Listado del día<input width="4" type="date" name="fechadia" id="fechadia" placeholder="Fecha" v-on:click=ajaxdelay() >
     <b-button variant="primary" v-on:click=ajax()>ACTUALIZAR</b-button>
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     :line-numbers="true"
     @on-cell-click="onCellClick"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">

    <span v-if="props.column.field == 'eliminar'">
       <b-button variant="outline-danger">Eliminar</b-button>
    </span>
    <span v-else-if="props.column.field == 'editar'">
       <b-button variant='danger'>Editar</b-button>
       
    </span>
    
    <span v-else>
       {{props.formattedRow[props.column.field]}}  
    </span>
    
  </template>
   </vue-good-table>
</div>
      </b-card-text>

     
     
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
// <qrcode-vue class='codigoQR' :value="value" :size="size" level="H" renderAs='canvas' background='#ffffff' foreground='#000000'></qrcode-vue>
//{{props.formattedRow[props.column.field]}}
import { WebCam } from "vue-web-cam"
 import QrcodeVue from 'qrcode.vue'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'
import eliminarOrigenBovinos from '../mixins/eliminarOrigenBovinos'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'FacturaGuia',
  data () {
    return {
      boton:'btn blue',
        value:'1',
        campostabla:false,
        PSG:'',
        selected2:'Porcino',
      msg: 'Número de arete',
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
        areteEditar:'',
        status:'NO VERIFICADO',
        status2:'NO VERIFICADO',
         result: '',
          isValid: undefined,
      camera: 'off',
      noStreamApiSupport: false,
      error: '',
      QRreemo:'',
      QRreemoreemo:'',
      uppOrigen:'',
      uppDestino:'',
      cantidadAnimales:'',
      fechaExp:'',
      QRForma:'',
      uppForma:'',
      cantidadForma:'',
      fechaForma:'',
      corregir:'',
      permisoForma:'',
      value: 'https://example.com',
        size: 300,
        text:'',
        
        img: null,
        img2: null,
        img3: null,
        img4: null,
            camera: null,
            deviceId: null,
            devices: [],
            show1:0,
            show2:0,
            show3:0,
            show4:0,
        
      columns:[
        {
          label:'Id',
          field:'id',
          hidden:true
        },
        {
          label:'REEMO',
          field:'reemo'
        },
        {
          label:'UPP',
          field:'upporigen'
        },
        {
          label:'Nombre.',
          field:'nombreorigen'
        },
        {
          label:'Fecha',
          field:'fechaexpedicion',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd'
        },
        {
          label:'Introductor',
          field:'nombredestino'
        },
        {
          label:'Cantidad',
          field:'cantidad'
        },
        {
          label:'Factura',
          field:'factura'
        },
        {
          label:'Corral',
          field:'corral'
        },
        {
          label:'Eliminar',
          field:'eliminar'
        },
      ],
      rows:[

      ]
    }
  },
  computed:{
      ...mapState(['usuarioActual','idActual','fotoActual']),
      validationPending() {
      return this.isValid === undefined
        && this.camera === 'off'
    },

    validationSuccess() {
      return this.isValid === true
    },

    validationFailure() {
      return this.isValid === false
    },

    device: function() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        }
    },
    watch: {
        camera: function(id) {
            this.deviceId = id;
        },
        devices: function() {
            // Once we have a list select the first one
            const [first, ...tail] = this.devices;
            if (first) {
                this.camera = first.deviceId;
                this.deviceId = first.deviceId;
            }
        }
  
  },
  mounted() {
    this.video = this.$refs.video;
    if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
            this.video.src = window.URL.createObjectURL(stream);
            this.video.play();
        });
    }
},  
  methods:{
    Borrar(a){
 if(a==1)
            {
             this.img=null
            }
            else if(a==2){
             this.img2=null
            }
            else if(a==3){
             this.img3=null
            }
            else{
             this.img4=null
            }
    },
    onCapture(a) {
       if(a==1)
            {
             this.img = this.$refs.webcam.capture();
            }
            else if(a==2){
             this.img2 = this.$refs.webcam.capture();
            }
            else if(a==3){
            this.img3 = this.$refs.webcam.capture();
            }
            else{
             this.img4 = this.$refs.webcam.capture();
            }
            
        },
        onStarted(stream) {
            console.log("On Started Event", stream);
        },
        onStopped(stream) {
            console.log("On Stopped Event", stream);
        },
        onStop(a) {
            this.$refs.webcam.stop();
             if(a==1)
            {
             this.show1=0
            }
            else if(a==2){
             this.show2=0
            }
            else if(a==3){
             this.show3=0
            }
            else{
             this.show4=0
            }
        },
        onStart(a) {
            this.$refs.webcam.start();
            if(a==1)
            {
             this.show1=1
            }
            else if(a==2){
             this.show2=1
            }
            else if(a==3){
             this.show3=1
            }
            else{
             this.show4=1
            }
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
            console.log("On Cameras Event", cameras);
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
            console.log("On Camera Change Event", deviceId);
        },
    onFileChange(event){
   var fileData =  event.target.files[0];
   this.text=fileData.name+fileData.size;
  //swal({ html:true, title:'<i>TITLE</i>', text:""});
},
    validarReemo(){
            
                const formData = new FormData()
                formData.append('reemo',this.QRForma)
                formData.append('unidadForma',this.unidad)
               /* EN caso de querer mandar más de un dato se repite varias veces y se cambia el nombre y la variable
                FormData.append('correo',this.correo)
                FormData.append('correo',this.correo)*/
                //axios.post('httpss://proyectocdnywebpack.000webhostapp.com/snippetWebpack/api/loginRegistro/validarEmail.php',formData)
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/validarReemo.php',formData)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            this.boton = 'btn blue'
                            this.corregir=''
                        } else {
                            this.boton = 'btn blue disabled'
                            this.corregir='La guía REEMO ya está registrada'
                            swal({
                    title:'La guía REEMO ya existe',
                    icon: 'error'}) 
                        }
                    })
    },
     validarpermiso(){
            
                const formData = new FormData()
                formData.append('permiso',this.permisoForma)
                formData.append('unidadForma',this.unidad)
               /* EN caso de querer mandar más de un dato se repite varias veces y se cambia el nombre y la variable
                FormData.append('correo',this.correo)
                FormData.append('correo',this.correo)*/
                //axios.post('httpss://proyectocdnywebpack.000webhostapp.com/snippetWebpack/api/loginRegistro/validarEmail.php',formData)
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/validarordensacrificio.php',formData)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            this.boton = 'btn blue'
                            this.corregir=''
                        } else {
                            this.boton = 'btn blue disabled'
                            this.corregir='La Orden de Sacrificio ya está registrada'
                            swal({
                    title:'La Orden de Sacrificio ya existe',
                    icon: 'error'}) 
                        }
                    })
    },
            
    variables(){
      this.fechaForma=document.getElementById('fechaexpedicion').value
      this.QRForma=document.getElementById('reemo').value
      this.uppForma=document.getElementById('upp').value
      this.cantidadForma=document.getElementById('cantidad').value
      this.permisoForma=document.getElementById('permiso').value
    },
    turnCameraOn() {
      this.camera = 'auto'
    },

    turnCameraOff() {
      if(this.camera=='off'){
         this.camera = 'auto'
      }
      else{
    this.camera = 'off'
      }
     
      
    },
    paintBlueDots(location, ctx) {
      const {
        topLeftFinderPattern,
        topRightFinderPattern,
        bottomLeftFinderPattern
      } = location

      const pointArray = [
        topLeftFinderPattern,
        topRightFinderPattern,
        bottomLeftFinderPattern
      ]

      ctx.fillStyle = '#007bff'

      pointArray.forEach(({ x, y }) => {
        ctx.fillRect(x - 5, y - 5, 10, 10)
      })
    },
     onDecode (result) {
      this.result = result
      //this.QRreemo=this.result.slice()
      this.QRreemo = this.result.split(',')
      this.QRreemoreemo=this.QRreemo[0].split('=')
      this.QRForma=this.QRreemoreemo[1]

      this.uppOrigen=this.QRreemo[1].split('=')
      this.uppForma=this.uppOrigen[1]
      this.uppDestino=this.QRreemo[2].split('=')
      this.PSG=this.uppDestino[1]

      this.cantidadAnimales=this.QRreemo[3].split('=')
      this.cantidadForma=this.cantidadAnimales[1]

      this.fechaExp=this.QRreemo[5].split('=')
      this.fechaForma=this.fechaExp[1]

    },
     logErrors (promise) {
      promise.catch(console.error)
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.noStreamApiSupport = true
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    },
      psgcorrespondiente(){
          if(this.unidad=='Rastro municipal de zapopan'||this.unidad=='Rastro de Zapopan'){
              this.PSG='141200005P03'
          }
      },
    nextPlease(){
      document.getElementById('factura').focus()
    },
     onCellClick(params) {
         if(params.column.field=="eliminar"){
       if(this.eliminarOrigenBovinos(params.row.id)){
            //swal('hola')
           
       } 
       else{
         setTimeout(() => {  this.ajax(); }, 3000)
       }        
        // setTimeout(() => {  this.ajax(); }, 5000);
        //this.ajax()
         
         }
         if(params.column.field=="editar"){
           const idquery=params.row.id
           
           //const aretequery=params.row.arete
           //swal('params.row.arete'+idquery)
           //const aretequery=props.formattedRow['sng']
           const aretequery=document.getElementById('aretetabla'+idquery).value
           const canalquery=document.getElementById('canaltabla'+idquery).value
           const inicialesquery=document.getElementById('inicialestabla'+idquery).value
           const facturaquery=document.getElementById('facturatabla'+idquery).value
           const guiaquery=document.getElementById('guiatabla'+idquery).value
           const permisoquery=document.getElementById('permisotabla'+idquery).value
           const sexoquery=document.getElementById('sexotabla'+idquery).value
          axios.get('https://micomidasegura.mx/comidaSegura/api/crud/editarAreteBovinos.php?id='+idquery+'&sng='+aretequery
          +'&canal='+canalquery+'&iniciales='+inicialesquery+'&factura='+facturaquery+'&guia='+guiaquery+'&permiso='+permisoquery+'&sexo='+sexoquery)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            swal('Registro editado')
                        } else {
                          swal('Error al editar registro' + res.data)
                        }
                    })}
         
         
        this.ajax()
         //
   // alert (params.row.id) // params.row - row object   /// 
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajax(){
      //this.getId()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     const fecha = document.getElementById("fechadia").value
     const unidadquery=this.unidad
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getOrigenBovinos.php?fecha='+fecha+'&unidad='+unidadquery+'&especie=Porcino')
      .then(response=>{
        this.rows=response.data
      })

    },
    ajaxdelay(){
      setTimeout(() => {  this.ajax(); }, 2500)
    },
    getId(){
           this.usuario()

            const id = document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+ id)
            
                .then(response=>{
                   
                    this.unidad = response.data.unidad
                  
                    
                })
                   
        }, 
    usuario(){
       // this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     this.usuariolocal= result
     const tok=this.usuariolocal
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    },
    registro(event){
            if(this.boton == 'btn blue disabled'){

            }
            else{
                //document.getElementById('usuarioForma').value=this.$store.state.usuario.token
                /*document.getElementById("usuarioForma").value =this.$store.state.usuarioActual
                document.getElementById("fotoForma").value =this.$store.state.fotoActual
                document.getElementById("idForma").value =this.$store.state.idActual*/
               //this.usuario()
               const form=document.getElementById('formRegistro')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarOrigenAnimalesFoto.php',new FormData(form))
                .then(res=>{
                    
                    if (res.data=='success') {
                        swal('Registro guardado con éxito')
                        setTimeout(() => {  event.target.reset() }, 500)
                         this.fechaForma=""
                        this.QRForma=""
                        this.uppForma=""
                        this.cantidadForma=""
                        this.permisoForma=""
                         this.status='NO VERIFICADO'
                       this.status2='NO VERIFICADO'
                       this.img=null
                       this.img2=null
                       this.img3=null
                       this.img4=null
                        
                //this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar'+res.data ,
                    icon: 'error'})  
            }
                    //this.ajax()
                    //this.ticketIncremento()
                       // document.getElementById("arete").value=""
                     // document.getElementById("arete").focus()
                   /*swal({
                   title:'Registro almacenado'+res.data,
                    //title:'Registro almacenado'+this.$localStorage.get('usuario')+this.$localStorage.getElementById('token'),
                    icon: 'success'})*/
                     
                    //this.direccionamiento()
                })
            }
            
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
   
    this.usuario()
  },
  components:{
     QrcodeVue,
    Cabecera,
    Menu,
    QrcodeStream, 
    QrcodeDropZone, 
    QrcodeCapture,
    WebCam
  },
  mixins:[sesion,eliminarOrigenBovinos]
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.error {
  font-weight: bold;
  color: red;
}

  #app {
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
    #video {
        background-color: #000000;
    }
    #canvas {
        display: none;
    }
    li {
        display: inline;
        padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/FacturaGuiaPorcinosFOTO.vue